// knb 会强制将分享链接转为 https
import Vue from 'vue'
import knbUse, { wxReady } from '@zhenguo/jssdk/knb/knb-use'
import { knbConfigShare, configSharePhxWxApp } from '@zhenguo/jssdk/knb/knb-share'
import { share } from '../share'
import { knbCaptrue } from '@zhenguo/jssdk/knb/knb-capture'

export default {
  install(app: typeof Vue) {
    app.prototype.$knbUse = knbUse
    app.prototype.$wxReady = wxReady
    app.prototype.$share = share
    app.prototype.$configShare = knbConfigShare
    app.prototype.$configSharePhxWxApp = configSharePhxWxApp
    app.prototype.$knbCaptrue = knbCaptrue
  },
}
